/**
 * Groups components that bind to the DOM.
 *
 * @module app/components/BindingComponents
 */
import DrawersAdapter from './DrawersAdapter';
import DropdownAdapter from './DropdownAdapter';
import Login from './Login';
import Navigation from './Navigation';
import SportsBanners from './banners/SportsBanners';

/**
 * Initialise this
 * @returns {void}
 * @private
 */
var init = function () {

    initWH();
    initWHSportsbook();

    window.WH.sportsbook.isLoggedIn = isLoggedIn;
    window.WH.sportsbook.ready = ready;
};

/**
 * Initialise the WH global.
 * @returns {void}
 * @private
 */
var initWH = function () {

    window.WH = window.WH || {};
};

/**
 * Initialise the WH.sportsbook global.
 * @returns {void}
 * @private
 */
var initWHSportsbook = function () {

    window.WH.sportsbook = window.WH.sportsbook || {};
};

/**
 * Determine whether the user is logged in.
 * @returns {Boolean} Logged In State
 * @private
 */
var isLoggedIn = function () {

    return Login.isLoggedIn();
};

/**
 * Notify sportsbook that an app is ready.
 * @returns {void}
 * @private
 */
var ready = function () {
};

/**
 * Methods to be public
 *
 * @type {Object}
 */
var api = {
    DrawersAdapter: DrawersAdapter,
    DropdownAdapter: DropdownAdapter,
    Login: Login,
    Navigation: Navigation,
    SportsBanners: SportsBanners,
};

init();

export default api;
